<!-- 发票详情 -->
<template>
  <div class="body">
    <van-nav-bar
      title="电子发票详情"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="center">
      <!-- 发票类型 -->
      <div class="top-box">
        <div class="top-title">发票类型</div>
        <div class="btn-box">
          <van-button :class="isCheck == '个人' ? 'check-btn' : 'no-btn'" @click="onBtn('个人')">个人</van-button>
          <van-button :class="isCheck == '企业' ? 'check-btn' : 'no-btn'" @click="onBtn('企业')">企业</van-button>
        </div>
      </div>
      <!-- 发票明细 -->
      <div class="btm-box">
        <div class="top-title">发票明细</div>
        <van-form class="qy-box">
          <!-- 发票抬头 -->
          <!--  :rules="fqRiseRul" -->
          <van-field v-model="obj.fqRise" placeholder="请输入" maxlength="100">
            <template #label>
              发票抬头 <span style="color: #FF7825">*</span>
            </template>
            <!-- <template #right-icon>
              <img src="../../assets/fu-wu/help.png" alt="">
            </template> -->
          </van-field>

          <van-cell class="fp-color" title="发票内容" value="燃气费" />
          <van-cell class="fp-color" title="发票金额" :value="fqMoney + '元'" />

          <van-field v-model="obj.email" placeholder="邮箱用于接收发票链接" :rules="emailRul">
            <template #label>
              联系人邮箱 <span style="color: #FF7825">*</span>
            </template>
            <template #right-icon>
              <van-popover v-model="emlShowPopover" theme="dark">
                <div class="div-pop">请输入您常用的电子邮箱（如QQ邮箱）</div>
                <template #reference>
                  <img src="../../assets/fu-wu/help.png" alt="" @click="emlShowPopover = true">
                </template>
              </van-popover>
            </template>
          </van-field>

          <van-field v-model="obj.phone" placeholder="请填写联系电话" :rules="telRules" maxlength="11">
            <template #label>
              电话 <span style="color: #FF7825">*</span>
            </template>
            <template #right-icon>
              <van-popover v-model="phoneShowPopover" theme="dark">
                <div class="div-pop">请输入11位数字的手机号</div>
                <template #reference>
                  <img src="../../assets/fu-wu/help.png" alt="" @click="phoneShowPopover = true">
                </template>
              </van-popover>
            </template>
          </van-field>

          <van-field v-model="obj.regNum" placeholder="请输入纳税人识别号" v-if="isCheck == '企业'" :rules="regNumPattern" maxlength="18">
            <template #label>
              纳税人识别号 <span style="color: #FF7825">*</span>
            </template>
            <template #right-icon>
              <van-popover v-model="regShowPopover" theme="dark">
                <div class="div-pop">1~18位数字或字母组合</div>
                <template #reference>
                  <img src="../../assets/fu-wu/help.png" alt="" @click="regShowPopover = true">
                </template>
              </van-popover>
            </template>
          </van-field>

          <van-cell title="更多开票信息" is-link :arrow-direction="isShowMore ? 'up' : 'down'" v-if="isCheck == '企业'" class="more" @click="onMore" />

          <van-field v-model="obj.beiZhu" placeholder="请输入备注" label="备注" v-if="isCheck == '个人'" maxlength="100">
            <template #right-icon>
              <van-popover v-model="qyBeiZhuShowPopover" theme="dark">
                <div class="div-pop">只允许输入汉字、阿拉伯数字，中文的（逗号，句号，冒号,顿号,分号），英文的（括号，逗号，句号，横杠，加号，分号，冒号）  大小写字母，长度限制为100个字符</div>
                <template #reference>
                  <img src="../../assets/fu-wu/help.png" alt="" @click="qyBeiZhuShowPopover = true">
                </template>
              </van-popover>
            </template>
          </van-field>
        </van-form>

        <!-- 更多开票信息 -->
        <van-form class="qy-more-box" v-if="isShowMore && isCheck == '企业'">
          <van-field v-model="obj.invBankName" placeholder="请填写开户行名称" label="开户行名称" :rules="invBankNamePattern" maxlength="70">
            <template #right-icon>
              <van-popover v-model="invBankNameShowPopover" theme="dark">
                <div class="div-pop">只允许输入汉字、大写字母、英文括号，不能有空格，长度限制为70个字符</div>
                <template #reference>
                  <img src="../../assets/fu-wu/help.png" alt="" @click="invBankNameShowPopover = true">
                </template>
              </van-popover>
            </template>
          </van-field>

          <van-field v-model="obj.invBankAcct" placeholder="请填写开户行账号" label="开户行账号" :rules="invBankAcctPattern" maxlength="30">
            <template #right-icon>
              <van-popover v-model="invBankAcctShowPopover" theme="dark">
                <div class="div-pop">只允许输入阿拉伯数字、英文横杠符号，长度限制为30个字符，不能有空格</div>
                <template #reference>
                  <img src="../../assets/fu-wu/help.png" alt="" @click="invBankAcctShowPopover = true">
                </template>
              </van-popover>
            </template>
          </van-field>

          <van-field v-model="obj.Gmfdz" placeholder="请填写公司地址" label="公司地址" :rules="GmfdzPattern" maxlength="70">
            <template #right-icon>
              <van-popover v-model="GmfdzShowPopover" theme="dark">
                <div class="div-pop">只允许输入汉字、阿拉伯数字、英文的（括号、横杠、&符号、#符号）、大小写字母，不能有空格，长度限制为70个字符</div>
                <template #reference>
                  <img src="../../assets/fu-wu/help.png" alt="" @click="GmfdzShowPopover = true">
                </template>
              </van-popover>
            </template>
          </van-field>

          <van-field v-model="obj.Gmfdh" placeholder="请填写公司联系电话" label="公司联系电话" :rules="GmfdhPattern" maxlength="18">
            <template #right-icon>
              <van-popover v-model="GmfdhShowPopover" theme="dark">
                <div class="div-pop">只允许输入数字、英文的（横杠，加号），长度限制为30个字符</div>
                <template #reference>
                  <img src="../../assets/fu-wu/help.png" alt="" @click="GmfdhShowPopover = true">
                </template>
              </van-popover>
            </template>
          </van-field>

          <van-field v-model="obj.qyBeiZhu" placeholder="请输入备注" label="备注" :rules="beiZhuPattern" maxlength="100">
            <template #right-icon>
              <van-popover v-model="qyBeiZhuShowPopover" theme="dark">
                <div class="div-pop">只允许输入汉字、阿拉伯数字，中文的（逗号，句号，冒号,顿号,分号），英文的（括号，逗号，句号，横杠，加号，分号，冒号）  大小写字母，长度限制为100个字符</div>
                <template #reference>
                  <img src="../../assets/fu-wu/help.png" alt="" @click="qyBeiZhuShowPopover = true">
                </template>
              </van-popover>
            </template>
          </van-field>
        </van-form>

        <!-- 注： -->
        <div class="btm-title">
          <div class="zhu">注：</div>
          <div class="main">
            <div>1、发票类型是增值税普通发票</div>
            <div>2、发票申请提交之后无法撤回</div>
            <div>3、如您对发票内容有特殊需求，请与拨打96777</div>
          </div>
        </div>

        <van-button type="danger" class="btm-btn" @click="onSubmit">提交</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { applyBilling, getData } from '../../api/bill'
export default {
  data () {
    return {
      // 发票抬头正则
      fqRiseRul: [{
        validator: value => {
          return /[^\u4e00-\u9fa50-9A-Za-z()#\-]/.test(value)
        },
        message: '请输入有效的发票抬头',
        trigger: 'onChange'
      }],
      // 邮箱校验正则
      emailRul: [{
        validator: value => {
          return /^\w[-\w.+]*@([A-Za-z0-9][-\w]+\.)+[A-Za-z]{2,14}$/.test(value)
        },
        message: '请输入合法的邮箱',
        trigger: 'onChange'
      }],
      // 手机号校验正则
      telRules: [{
        validator: value => {
          return /[0-9]{11}/.test(value)
        },
        message: '请输入有效的手机号',
        trigger: 'onChange'
      }],
      // 纳税人识别号校验正则
      regNumPattern: [{
        validator: value => {
          return /^[a-zA-Z0-9]{1,18}$/.test(value)
        },
        message: '请填写有效的纳税人识别号',
        trigger: 'onChange'
      }],
      // 开户行名称
      invBankNamePattern: [
        { required: false },
        {
          validator: value => {
            return /[^\u4e00-\u9fa5A-Z()]/.test(value)
          },
          message: '请输入有效的开户行名称',
          trigger: 'onChange'
        }],
      // 开户行账号
      invBankAcctPattern: [
        { required: false },
        {
          validator: value => {
            return /[^0-9\-]/.test(value)
          },
          message: '请输入有效的开户行账号',
          trigger: 'onChange'
        }],
      // 公司地址
      GmfdzPattern: [
        { required: false },
        {
          validator: value => {
            return /[^\u4e00-\u9fa50-9A-Za-z()#&\-]/.test(value)
          },
          message: '请输入有效的公司地址',
          trigger: 'onChange'
        }],
      // 公司联系电话
      GmfdhPattern: [
        { required: false },
        {
          validator: value => {
            return /[^0-9\-\+]/.test(value)
          },
          message: '请输入有效的公司联系电话',
          trigger: 'onChange'
        }],
      // 备注信息
      beiZhuPattern: [
        { required: false },
        {
          validator: value => {
            return /[^\u4e00-\u9fa50-9A-Za-z，。：、；(),.:;\-\+]/.test(value)
          },
          message: '请输入有效的备注信息',
          trigger: 'onBlur'
        }],
      // 点击？的提示，气泡框
      emlShowPopover: false,
      phoneShowPopover: false,
      regShowPopover: false,
      invBankNameShowPopover: false,
      invBankAcctShowPopover: false,
      GmfdzShowPopover: false,
      GmfdhShowPopover: false,
      qyBeiZhuShowPopover: false,
      isCheck: '企业',
      fqMoney: 0,
      // selectArr: [],
      obj: {
        fqRise: '',
        email: '',
        phone: '',
        num: '',
        regNum: ''
      },
      isShowMore: false,
      gasAccountInfo: {} // 户号信息
    }
  },
  created () {
    this.gasAccountInfo = this.$route.params.gasAccountInfo
    const selectArr = this.$route.params.arr
    selectArr.forEach(item => {
      this.fqMoney = this.fqMoney + Number(item.payAmt)
    })
    this.getApi()
  },
  methods: {
    // 企业类型，查询纳税识别号
    getApi () {
      const that = this
      // 发票开票信息查询
      const pa = {
        'CM-CXFPINFO': {
          input: {
            // acctId: this.$store.state.cardObj.userCode
            acctId: that.gasAccountInfo.gasAccount
          }
        }
      }
      getData(JSON.stringify(pa)).then(res => {
        if (res.data && res.data['soapenv:Envelope'] && res.data['soapenv:Envelope']['soapenv:Body'] && res.data['soapenv:Envelope']['soapenv:Body']['CM-CXFPINFO'] && res.data['soapenv:Envelope']['soapenv:Body']['CM-CXFPINFO'].fpInfo) {
          const data = res.data['soapenv:Envelope']['soapenv:Body']['CM-CXFPINFO'].fpInfo
          that.obj.regNum = data.TaxRegNum ? data.TaxRegNum : ''
        }
      })
    },
    // 返回上一页
    onClickLeft () {
      this.$router.go(-1)
    },
    // 企业、个人按钮切换
    onBtn (val) {
      if (val === '企业') {
        this.getApi()
      }
      this.isCheck = val
    },
    // 点击更多开票信息
    onMore () {
      this.isShowMore = !this.isShowMore
    },
    // 提交
    onSubmit () {
      if (this.obj.fqRise === '') {
        this.$toast.fail('请输入必填信息')
        return
      }
      if (this.obj.email === '') {
        this.$toast.fail('请输入必填信息')
        return
      }
      if (this.obj.phone === '') {
        this.$toast.fail('请输入必填信息')
        return
      }
      const that = this
      this.$dialog.confirm({
        message: '发票申请提交后无法撤回，请确认您填写的信息无误'
      }).then(() => {
        that.$toast.loading({
          message: '加载中...',
          forbidClick: true,
          duration: 0
        })
        // 申请开票接口
        const params = {
          // uniUserCode: this.$store.state.cardObj.userCode,
          uniUserCode: that.gasAccountInfo.gasAccount,
          invType: this.isCheck === '企业' ? 'B' : 'R', // 发票类型
          invTit: this.obj.fqRise, // 发票抬头
          invCnt: '燃气费',
          invPri: this.fqMoney, // 发票金额
          phoNum: this.obj.phone, // 电话
          emailAdr: this.obj.email, // 邮箱
          uniUserPhoneNum: JSON.parse(window.localStorage.userInfo).mobile, // 登录用户手机号
          taxRegNum: this.isCheck === '企业' ? this.obj.regNum : '', // 纳税人识别号
          ftList: this.$route.params.arr,
          invBankName: this.obj.invBankName ? this.obj.invBankName : '', // 开户行名称
          invBankAcct: this.obj.invBankAcct ? this.obj.invBankAcct : '', // 开户行账号
          Gmfdz: this.obj.Gmfdz ? this.obj.Gmfdz : '', // 公司地址
          Gmfdh: this.obj.Gmfdh ? this.obj.Gmfdh : '', // 公司联系电话
          bz: this.isCheck === '企业' ? this.obj.qyBeiZhu : this.obj.beiZhu
        }
        applyBilling(params).then(res => {
          console.log(res)
          if (res && res.data.success) {
            that.$toast.success('开票申请提交成功，请您到邮箱查看')
          } else {
            that.$toast.fail(res.data.message ? res.data.message : '开票失败')
          }
        }).catch(() => {
          that.$toast.fail('请求失败')
        })
      }).catch(() => {
        that.$toast('取消提交')
      })
    }

  }
}
</script>

<style scoped>
.body {
  width: 100%;
  height: 100%;
  background: #F7F7FA;
}
.center {
  height: calc(100% - 45px);
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.center >>> .van-cell {
  font-size: 16px;
}
.top-box {
  background: #fff;
  padding: 0 20px;
  box-sizing: border-box;
  height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}
.btm-box {
  height: calc(100% - 130px);
  width: 100%;
  padding: 20px;
  overflow: auto;
  box-sizing: border-box;
  margin-top: 10px;
  background: #fff;
}
.btm-btn {
  background: #CE0022;
  box-shadow: 0px 6px 12px rgba(206, 0, 34, 0.3);
  opacity: 1;
  border-radius: 8px;
  width: 100%;
  height: 50px;
}
.top-title {
  font-size: 22px;
  font-weight: 500;
  line-height: 31px;
  color: #27282E;
}
.btn-box {
  display: flex;
  justify-content: space-between;
}
.no-btn, .check-btn {
  height: 50px;
  border: 1px solid #CE0022;
  border-radius: 8px;
  color: #CE0022;
  font-size: 18px;
  width: 48%;
}
.check-btn {
  background: #CE0022;
  color: #fff;
}
.fp-color .van-cell__title {
  color: #62667A;
}
.fp-color .van-cell__value, .btm-box >>> .van-field__label {
  color: #27282E;
}
.more .van-cell__title, .more .van-cell__right-icon {
  color: #CE0022;
}
.qy-box >>> .van-field__label {
  width: 100%;
}
.btm-box img {
  width: 20px;
  height: 20px;
}
.qy-box .van-cell.van-field {
  display: flex;
  flex-direction: column;
}
.btm-title {
  font-size: 14px;
  color: #999999;
  display: flex;
  margin: 15px 0;
}
.div-pop {
  border-radius: 2px;
  padding: 10px;
  font-size: 12px;
}

</style>
